<template>
  <div class="flex items-center">
    <a
      href="/browse/after-effects-templates/"
      class="link category"
      :class="{ 'category--active': active.includes('templates') }"
      @mouseover="$emit('hovered', 'templates')"
    >
      Templates
    </a>

    <a
      href="/browse/after-effects-presets/"
      class="link category"
      :class="{ 'category--active': active.includes('presets') }"
      @mouseover="$emit('hovered', 'presets')"
    >
      Presets
    </a>

    <a
      href="/browse/luts/"
      class="link category"
      :class="{ 'category--active': active.includes('luts') }"
      @mouseover="$emit('hovered', 'luts')">
      LUTs
    </a>

    <a
      href="/browse/voice-over/"
      class="link category"
      :class="{ 'category--active': active.includes('voiceover') }"
      @mouseover="$emit('hovered', 'voiceover')">
      <img src="/assets/images/shared/stars.png" class="mr-[6px] w-auto max-w-none" />
      Voiceover
    </a>

    <a
      href="/browse/royalty-free-music/"
      class="link category"
      :class="{ 'category--active': active.includes('audio') }"
      @mouseover="$emit('hovered', 'audio')">
      Audio
    </a>

    <a
      href="/browse/stock-video/"
      class="link category"
      :class="{ 'category--active': active.includes('video') }"
      @mouseover="$emit('hovered', 'video')"
    >
      Videos
    </a>

    <a
      href="/browse/graphics/"
      class="link category"
      :class="{ 'category--active': active.includes('images') }"
      @mouseover="$emit('hovered', 'images')"
    >
      Images
    </a>

    <div
      style="background: #C4C4C4; width: 1px; height: 22px; margin-left: 20px; margin-right: 20px;"
    />

    <a
      href="/plugins/"
      class="link category"
      :class="{ 'category--active': active.includes('plugins') }"
      @mouseover="$emit('hovered', 'plugins')"
    >
      Plugins
    </a>

    <a
      href="/learn/"
      target="_blank"
      class="link category"
      :class="{ 'category--active': active.includes('learn') }"
      @mouseover="$emit('hovered', 'learn')"
    >
      Blog
    </a>

    <a
      v-if="$store.getters.userType !== 'paid'"
      href="/pricing/"
      class="link category"
      :class="{ 'category--active': active.includes('pricing') }"
      @mouseover="$emit('hovered', 'pricing')"
    >
      Pricing
    </a>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Array,
      default: () => [],
    }
  },
};
</script>

<style scoped>
.link {
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 16px;
  cursor: pointer;

  @apply text-primary-gray;
}
.text-\[10px\] {
  font-size: 10px;
}
.py-\[2px\] {
  padding-top: 2px;
  padding-bottom: 2px;
}
.px-\[4px\] {
  padding-right: 4px;
  padding-left: 4px;
}
.mr-\[6px\] {
  margin-right: 6px;
}
.category {
  padding-left: 10px;
  padding-right: 10px;
  font-size: 14px;
  position: relative;
}

.link:hover,
.link.category--active {
  @apply text-white;
  box-shadow: 0px -5px 0px 0px #534CDA inset;
}

@screen 1xl {
  .category {
    padding-left: 20px;
    padding-right: 20px;
    font-size: 16px;
  }
}
</style>

